/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

export * from './platform';
export * from './platform-module';
export * from './features/input-types';
export * from './features/passive-listeners';
export * from './features/scrolling';
export * from './features/shadow-dom';
export * from './features/test-environment';
